import React, { useState, useEffect } from 'react'
import PropTypes from "prop-types";
import { getServiceability, schedulePickup, validateDtdcCourierDetails } from '../../helper';
// import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
// import moment from 'moment';
import { DELIVERY_PARTNER_IDS_MAP, DEFAULT_PICKUP_PINCODE } from '../../constants';

const CourierDetailsForm = ({ backButton, deliveryData, setDeliveryData, userPatientAddresses, onContinue }) => {
    const [couriersData, setCouriersData] = useState([]);
    const [loading, setLoading] = useState(false);

    const setCourierId = (courierId) => {
        setDeliveryData((prevState) => {
            return {
                ...prevState,
                serviceType: courierId,
            }
        })
    }

    const handleSchedulePickup = async () => {
        if (!validateDtdcCourierDetails(deliveryData)) {
            return;
        }

        setLoading(true);

        const scheduledDelivery = await schedulePickup(deliveryData);
        if (scheduledDelivery && scheduledDelivery.success) {
            onContinue();
        }

        setLoading(false);
    }

    useEffect(() => {
        (async () => {
            if (deliveryData.billingAddressId) {
                setCourierId('');
                const deliveryPincode = userPatientAddresses.find(address => address.id === deliveryData.billingAddressId).pincode;
                if (deliveryPincode) {
                    const data = {
                        pickup: DEFAULT_PICKUP_PINCODE,
                        delivery: deliveryPincode,
                    }
                    const serviceabilityResponse = await getServiceability(DELIVERY_PARTNER_IDS_MAP.DTDC, data, deliveryData?.packageDetails?.containsLiquid, deliveryData?.packageDetails?.isCod);
                    if (serviceabilityResponse) {
                        setCouriersData(serviceabilityResponse);
                    }
                }
            }
        })()
    }, [deliveryData.billingAddressId, userPatientAddresses, deliveryData.packageDetails])

    const buttonDisabled = loading || !deliveryData?.serviceType

    return (
        <div className='flex flex-col gap-[0.9rem]' >
            <div className='flex justify-start items-start' >
                {backButton()}
            </div>
            <div className='flex flex-col' >
                {
                    <>
                        <span className='font-semibold text-[1.2rem] mb-[12px]' >Available Services</span>
                        <div className='flex flex-col gap-[1rem] overflow-scroll no-scrollbar' >
                            {
                                couriersData.couriers?.map((courier) => {
                                    return (
                                        <div onClick={() => setCourierId(courier.NAME)} key={courier.NAME} className={`cursor-pointer flex justify-between p-[1rem] rounded-[10px] border-[1px] ${deliveryData.serviceType === courier.NAME ? "border-[#28A48B] bg-[#eaf6f3]" : "border-[#fff] bg-gray-100"}`} >
                                            <div className='flex flex-col gap-[0.5rem] !items-start' >
                                                <span className='font-medium text-[1rem]' >{courier.NAME}</span>
                                            </div>
                                            <div className='flex flex-col gap-[0.5rem] items-start'>
                                                <span className='flex justify-between gap-[1rem] w-full' ><span className='font-semibold' >TAT: </span>{courier.TAT}</span>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </>
                }
            </div>
            <div className='flex justify-end' >
                <button onClick={handleSchedulePickup} disabled={buttonDisabled} className={`bg-[#28A48B] p-[1rem] rounded-[0.5rem] text-white-50 font-semibold ${buttonDisabled ? "opacity-50 cursor-not-allowed" : ""}`} >{loading ? "Scheduling" : "Schedule Pickup"}</button>
            </div>
        </div>
    )
}

CourierDetailsForm.propTypes = {
    deliveryData: PropTypes.object.isRequired,
    setDeliveryData: PropTypes.func.isRequired,
    userPatientAddresses: PropTypes.object.isRequired,
    onContinue: PropTypes.func.isRequired,
    backButton: PropTypes.element.isRequired
};

export default CourierDetailsForm